import ChatContext from "@/shared/models/ChatContext";
import { useApiPrivateRequest } from "@/shared/hooks/useApi";

interface ImproveChatInputRequest {
  input: string;
  companyIds?: number[];
  filingIds?: string[];
  transcriptIds?: string[];
  userDocumentIds?: string[];
  description?: string;
}

export const useImproveInput = () => {
  const {
    data: improvedInput,
    call,
    isLoading,
  } = useApiPrivateRequest<string>((response) => response);

  const improveInput = async (
    input: string,
    chatContext?: ChatContext,
    description?: string,
    chatId?: string,
  ) => {
    const data = chatContext?.extractChatCreateData();
    const request: ImproveChatInputRequest = {
      input,
      description,
      companyIds: data?.companyIds,
      filingIds: data?.filingIds,
      transcriptIds: data?.transcriptIds,
      userDocumentIds: data?.userDocumentIds,
    };

    return await call("/chats/input/improve", "POST", { chatId }, request);
  };

  return { improvedInput, improveInput, isLoading };
};
